import { create } from 'zustand';

export type ZstdInfo = {
  setShowUserPopup: (v: boolean) => void;
  showUserPopup: boolean;
  setShowLoginPopup: (v: boolean) => void;
  showLoginPopup: boolean;
  setIsLoginPopup: (v: boolean) => void;
  isLoginPopup: boolean;
  setShowManageMyInfoPopup: (v: boolean) => void;
  showManageMyInfoPopup: boolean;
  setShowPasswordResetPopup: (v: boolean) => void;
  showPasswordResetPopup: boolean;
  setShowSearchBoxPopup: (v: boolean) => void;
  showSearchBoxPopup: boolean;
  setShowSendPasswordResetEmailPopup: (v: boolean) => void;
  showSendPasswordResetEmailPopup: boolean;
  setShowSendVerifyEmailPopup: (v: boolean) => void;
  showSendVerifyEmailPopup: boolean;
  setShowSignupPopup: (v: boolean) => void;
  showSignupPopup: boolean;
  setShowSignupSocialPopup: (v: boolean) => void;
  showSignupSocialPopup: boolean;
  setShowTermsDetailPopup: (v: boolean) => void;
  showTermsDetailPopup: boolean;
  setShowTermsDetailPrivatePopup: (v: boolean) => void;
  showTermsDetailPrivatePopup: boolean;
  setSearchInput: (v: string) => void;
  searchInput: string; // input 값변경시 즉시 반영.
  searchKeyword: string; // 검색키워드. 엔터 또는, 버튼 클릭시 ==> 검색 트리거.
  setSearchKeyword: (v: string) => void;
  setShowInfoPopup: (v: boolean) => void;
  showInfoPopup: boolean;
  setShowOverThirteenPopup: (v: boolean) => void;
  showOverThirteenPopup: boolean;
  setShowMobileMenu: (v: boolean) => void;
  showMobileMenu: boolean; // 모바일 GNB 메뉴 열림 여부(메인페이지 Header 노출/닫기 아이콘 동기화용)
};
export const useZstdInfo = create<ZstdInfo>((set) => ({
  setShowUserPopup: (v: boolean) => set({ showUserPopup: v }),
  showUserPopup: false,
  setShowLoginPopup: (v: boolean) => set({ showLoginPopup: v }),
  showLoginPopup: false,
  setIsLoginPopup: (v: boolean) => set({ isLoginPopup: v }),
  isLoginPopup: false,
  setShowManageMyInfoPopup: (v: boolean) => set({ showManageMyInfoPopup: v }),
  showManageMyInfoPopup: false,
  setShowPasswordResetPopup: (v: boolean) => set({ showPasswordResetPopup: v }),
  showPasswordResetPopup: false,
  setShowSearchBoxPopup: (v: boolean) => set({ showSearchBoxPopup: v }),
  showSearchBoxPopup: false,
  setShowSendPasswordResetEmailPopup: (v: boolean) => set({ showSendPasswordResetEmailPopup: v }),
  showSendPasswordResetEmailPopup: false,
  setShowSendVerifyEmailPopup: (v: boolean) => set({ showSendVerifyEmailPopup: v }),
  showSendVerifyEmailPopup: false,
  setShowSignupPopup: (v: boolean) => set({ showSignupPopup: v }),
  showSignupPopup: false,
  setShowSignupSocialPopup: (v: boolean) => set({ showSignupSocialPopup: v }),
  showSignupSocialPopup: false,
  setShowTermsDetailPopup: (v: boolean) => set({ showTermsDetailPopup: v }),
  showTermsDetailPopup: false,
  setShowTermsDetailPrivatePopup: (v: boolean) => set({ showTermsDetailPrivatePopup: v }),
  showTermsDetailPrivatePopup: false,
  setSearchInput: (v: string) => set({ searchInput: v }),
  searchInput: '',
  searchKeyword: '',
  setSearchKeyword: (v: string) => set({ searchKeyword: v }),
  setShowInfoPopup: (v: boolean) => set({ showInfoPopup: v }),
  showInfoPopup: false,
  setShowOverThirteenPopup: (v: boolean) => set({ showOverThirteenPopup: v }),
  showOverThirteenPopup: false,
  setShowMobileMenu: (v: boolean) => set({ showMobileMenu: v }),
  showMobileMenu: false,
}));

type WithStoreProps<T> = T & ZstdInfo;

export const withZstdInfo = <P extends object>(WrappedComponent: React.ComponentType<WithStoreProps<P>>) => {
  const WithStoreComponent = (props: P) => {
    const store = useZstdInfo();
    return <WrappedComponent {...props} {...store} />;
  };

  WithStoreComponent.displayName = `withZstdInfo(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return WithStoreComponent;
};
